import { Modal } from "react-bootstrap";
import { AltButton, ActionButton } from "../../common/Buttons/Buttons";
import { Dropzone, FileComponent } from "../../common/Dropzone/Dropzone";
import "../../common/Modals/Modals.scss";

export const UploadRideryCodesModal = ({
    handleCloseModal,
    show,
    fileUploaded,
    setFileUploaded,
    getInputProps,
    getRootProps,
    message,
    upload,
  } ) => {

  const close = () => {
    handleCloseModal();
  };

  return (
    <Modal size="lg" centered show={show} onHide={() => close()}>
      <Modal.Header closeButton className="modal-header"></Modal.Header>
      <Modal.Body className="modal-body">
        <h1 style={{ marginBottom: "32px" }}>Cargar códigos Ridery</h1>
        <p>{"Campo Obligatorio (*)"}</p>
        <div
          className="dropzone-container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h6>
            <b>Adjuntar archivo de códigos de descuentos para Ridery</b>
          </h6>
          <h6>
            <b>{"(.xlsx)"}</b>
          </h6>
          {fileUploaded ? (
            <FileComponent
              file={fileUploaded}
              remove={() => setFileUploaded("")}
            />
          ) : (
            <Dropzone
              getRootProps={getRootProps}
              getInputProps={getInputProps}
              message={message}
            />
          )}
        </div>
      </Modal.Body>
      <div className="buttons-center-container">
        <AltButton label={"Cancelar"} action={() => close()} />
        {fileUploaded && (
          <ActionButton label={"Cargar Archivo"} action={() => upload()} />
        )}
      </div>
    </Modal>
  );
};